import { useCallback } from 'react';
import type { SavedConfig, TextAlign } from '../types';

export const useExtraStylesConfig = (
  savedConfig: SavedConfig,
  updateSavedConfig: (newValue: SavedConfig) => void,
) => {
  const { isBold, isItalic, isUnderlined, textColor, backgroundColor, textAlign } = savedConfig;

  const onClickBold = useCallback(
    () => updateSavedConfig({ ...savedConfig, isBold: !isBold }),
    [savedConfig, updateSavedConfig, isBold],
  );

  const onClickItalic = useCallback(
    () => updateSavedConfig({ ...savedConfig, isItalic: !isItalic }),
    [savedConfig, updateSavedConfig, isItalic],
  );

  const onClickUnderlined = useCallback(
    () => updateSavedConfig({ ...savedConfig, isUnderlined: !isUnderlined }),
    [savedConfig, updateSavedConfig, isUnderlined],
  );

  const onChangeTextColor = useCallback(
    (v: string | undefined) => updateSavedConfig({ ...savedConfig, textColor: v }),
    [savedConfig, updateSavedConfig],
  );

  const onChangeBackgroundColor = useCallback(
    (v: string | undefined) => updateSavedConfig({ ...savedConfig, backgroundColor: v }),
    [savedConfig, updateSavedConfig],
  );

  const onClickTextAlign = useCallback(
    (v: TextAlign) => () =>
      updateSavedConfig({
        ...savedConfig,
        textAlign: v === textAlign ? undefined : v,
      }),
    [savedConfig, updateSavedConfig, textAlign],
  );

  return {
    isBold,
    isItalic,
    isUnderlined,
    textColor,
    backgroundColor,
    textAlign,
    onClickBold,
    onClickItalic,
    onClickUnderlined,
    onChangeTextColor,
    onChangeBackgroundColor,
    onClickTextAlign,
  };
};
